export default __webpack_public_path__ + "assets/aa3214.svg";